import { ChromeTooltip } from '../ChromeTooltip'

export type ComicSaveStatus = 'saved' | 'dirty' | 'saving'

export function saveStatusLabel(status: ComicSaveStatus): string {
  return status === 'saving' ? '保存中' : status === 'dirty' ? '未保存' : '已保存'
}

/** 实心状态点颜色（无描边，用于标签内列表圆点） */
export function saveStatusDotClass(status: ComicSaveStatus, onAccentBg = false): string {
  if (onAccentBg) {
    return status === 'saving'
      ? 'bg-[rgb(254_239_218)]'
      : status === 'dirty'
        ? 'bg-[rgb(251_218_223)]'
        : 'bg-white'
  }
  return status === 'saving'
    ? 'bg-[rgb(234_179_89)]'
    : status === 'dirty'
      ? 'bg-[rgb(236_148_157)]'
      : 'bg-[var(--accent)]'
}

export function ComicSaveStatusDot({
  status,
  angular,
  onAccentBg = false,
  className = '',
}: {
  status: ComicSaveStatus
  angular: boolean
  onAccentBg?: boolean
  className?: string
}) {
  const label = saveStatusLabel(status)
  return (
    <ChromeTooltip content={label} angular={angular} side="top" align="center">
      <span
        className={['inline-block h-1.5 w-1.5 shrink-0 rounded-full', saveStatusDotClass(status, onAccentBg), className].join(
          ' ',
        )}
        aria-label={label}
      />
    </ChromeTooltip>
  )
}
